import { hpkeSeal, parsePublicKey } from "../shared/credentials/hpkeFormat";

let sealingKey: string | null | undefined;

export function setSealingKey(key: string | null | undefined) {
  sealingKey = key;
}

export async function sealSecret(plaintext: string): Promise<string> {
  if (sealingKey === undefined) {
    throw new Error("sealing a secret before SignedIn loaded the tenant key");
  }
  if (sealingKey === null) return plaintext;
  return hpkeSeal(plaintext, await parsePublicKey(sealingKey));
}
